import { CitationNode } from '@livv/models';
import { SxProps } from '@mui/material';
import { FC, PropsWithChildren } from 'react';
import { PlainLink } from '@components/Links';
import useAmplitude from '@utils/hooks/useAmplitude';
import useDocumentLink from '@utils/hooks/useDocumentLink';
import { TrackingEventName } from '@utils/types/amplitude/events';

interface InternalPreviewProps {
    citation: CitationNode;
    sx: SxProps;
}

const InternalPreview: FC<PropsWithChildren<InternalPreviewProps>> = ({
    children,
    citation,
    sx,
}) => {
    const [link, loading] = useDocumentLink(citation);
    const { id, type } = citation;
    const { track } = useAmplitude();

    const handleClick = () => {
        track({
            name: TrackingEventName.SIDE_EXTRA_CONTENT_CLICKED,
            params: {
                target_document_id: id,
                target_document_type: type,
            },
        });
    };
    if (loading) return null;

    return (
        <PlainLink href={link || ''} onClick={handleClick} sx={sx} underline="never">
            {children}
        </PlainLink>
    );
};

export default InternalPreview;
